import { Component, OnInit, ElementRef, Input, ViewChild } from "@angular/core";
import { BaseRubric } from "app/rubrics/base-rubric";
import { ActivatedRoute } from "@angular/router";
import { AppServices } from "app/app.services";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { HttpService } from "app/services/http.service";
import { ApplicationModel } from "app/core/models/application.model";

@Component({
	selector: "app-acp-remedies",
	templateUrl: "./remedies.component.html",
	styleUrls: ["./remedies.component.scss"],
})
export class RemediesAcpComponent implements OnInit {
	@Input() xmlPath: string;
	@ViewChild("remediesHTML", { static: true }) remediesHTML;

	private remedyData = "";
	private _currentPage = 1;
	private _totalPages = 0;
	private arrAccordion = [];
	public isHyperlinkOpen = false;
	public hyperLinkData = "";
	public isLoadFile = false;
	public textDirection: string;

	constructor(private httpService: HttpService) {}

	ngOnInit() {
		this.textDirection = ApplicationModel.instance.flowDirection;
		console.log(this.xmlPath);
		if (this.xmlPath != "") this.parseXML();
	}

	private parseXML() {
		console.log(this.xmlPath);
		this.httpService.get(this.xmlPath).then((res: any) => {
			this.remedyData = res;
			let remData: any = new DOMParser().parseFromString(
				this.remedyData,
				"text/xml"
			);
			this._totalPages = remData.getElementsByTagName("page").length;
			this.setPageData();
		});
	}

	public continueClick() {
		if (!this.isHyperlinkOpen) this._currentPage++;

		this.setPageData();
	}
	public setPageData() {
		let remData = new DOMParser().parseFromString(this.remedyData, "text/xml");
		this.arrAccordion = [];
		this.isHyperlinkOpen = false;

		let pageStr = "<div></div>";
		if (this._currentPage < remData.getElementsByTagName("page").length) {
			for (
				let i = 0;
				i <
				remData
					.getElementsByTagName("page")
					[this._currentPage].getElementsByTagName("block").length;
				i++
			) {
				pageStr += "<div>";
				console.log(
					remData
						.getElementsByTagName("page")
						[this._currentPage].getElementsByTagName("block")
						[i].getElementsByTagName("accordion")
				);
				if (
					remData
						.getElementsByTagName("page")
						[this._currentPage].getElementsByTagName("block")
						[i].getElementsByTagName("accordion").length > 0
				) {
					pageStr += "<div>";
					for (
						let j = 0;
						j <
						remData
							.getElementsByTagName("page")
							[this._currentPage].getElementsByTagName("block")
							[i].getElementsByTagName("accordion").length;
						j++
					) {
						pageStr += "<div>";
						pageStr += "<div id='clickable_" + j + "' role='button'>";
						pageStr += remData
							.getElementsByTagName("page")
							[this._currentPage].getElementsByTagName("block")
							[i].getElementsByTagName("accordion")
							[j].getElementsByTagName("clickable")[0].textContent;
						pageStr += "</div>";
						pageStr += "<div id='paragraph_" + j + "'>";
						pageStr += remData
							.getElementsByTagName("page")
							[this._currentPage].getElementsByTagName("block")
							[i].getElementsByTagName("accordion")
							[j].getElementsByTagName("paragraph")[0].textContent;
						pageStr += "</div>";
						pageStr += "</div>";
						this.arrAccordion.push(
							remData
								.getElementsByTagName("page")
								[this._currentPage].getElementsByTagName("block")
								[i].getElementsByTagName("accordion")
								[j].getElementsByTagName("clickable")[0].textContent
						);
					}
				} else {
					pageStr += "<div>";
					for (
						let j = 0;
						j <
						remData
							.getElementsByTagName("page")
							[this._currentPage].getElementsByTagName("block")
							[i].getElementsByTagName("paragraph").length;
						j++
					) {
						pageStr += "<div>";
						pageStr += remData
							.getElementsByTagName("page")
							[this._currentPage].getElementsByTagName("block")
							[i].getElementsByTagName("paragraph")[j].textContent;
						pageStr += "</div>";
					}
					pageStr += "</div>";
				}
				pageStr += "</div>";
			}
			pageStr = pageStr.replace(/<title>/g, "<p>");
			pageStr = pageStr.replace(/<h1>/g, "<b>");
			pageStr = pageStr.replace(/<\/h1>/g, "</b>");
			pageStr = pageStr.replace(/<b>/g, "<b>");
			pageStr = pageStr.replace(/<br><br>/g, "<br><br>");
			pageStr = pageStr.replace(/<a/g, "<a id='hyperlink'");
			pageStr = pageStr.replace(/<\/a>/g, "</a>");
			document.getElementById("remediesHTML").innerHTML = "<div></div>";
			// document.getElementById('remediesHTML').scrollTo(0, 0);
			// console.log("AK", document.getElementById('remediesHTML').innerHTML);
			setTimeout(() => {
				document.getElementById("remediesHTML").innerHTML = pageStr;
				let classRef = this;
				for (let i = 0; i < this.arrAccordion.length; i++) {
					console.log(document.getElementById("clickable_" + i));
					document
						.getElementById("clickable_" + i)
						.addEventListener("click", function () {
							classRef.onAccordionClick(i);
						});
					document.getElementById("paragraph_" + i).style.display = "none";
					document.getElementById("clickable_" + i).style.textDecoration =
						"underline";
					document.getElementById("clickable_" + i).style.color = "#0000FF";
					document.getElementById("clickable_" + i).style.cursor = "pointer";
					//document.getElementById('accordion_'+i).cla
				}
				//
				if (document.getElementById("hyperlink")) {
					let hyperlink = document
						.getElementById("hyperlink")
						.getAttribute("href");
					hyperlink = hyperlink.split("event:").join("");
					hyperlink = hyperlink.split(".swf").join(".html");
					//console.log(hyperlink);
					document.getElementById("hyperlink").style.textDecoration =
						"underline";
					document.getElementById("hyperlink").style.color = "#0000FF";
					document.getElementById("hyperlink").style.cursor = "pointer";
					//console.log(document.getElementById('hyperlink').getAttribute("href"));
					document
						.getElementById("hyperlink")
						.addEventListener("click", function () {
							classRef.onAnchorTagClick(hyperlink);
						});
				}
			}, 100);
			//this.remediesHTML.innerHTML = pageStr;
			//this.page = pageStr;
		}
	}

	public onAccordionClick(id) {
		for (let i = 0; i < this.arrAccordion.length; i++) {
			document.getElementById("paragraph_" + i).style.display = "none";
		}
		document.getElementById("paragraph_" + id).style.display = "block";
	}

	public onAnchorTagClick(path) {
		this.isHyperlinkOpen = true;
		this.hyperLinkData = path;
		window.scrollTo(0, 0);
		if (this.isLoadFile) {
			var Inneriframe: any = window.document.getElementById("ifrm_hyperlink");
			Inneriframe.src = Inneriframe.src;
			Inneriframe.contentWindow.focus();
		}
		if(document.getElementById('hyperlink').tagName.toLocaleLowerCase() === 'a') {
			event.preventDefault();
		}
	}

	public get currentPage(): number {
		return this._currentPage;
	}

	public set currentPage(val: number) {
		this._currentPage = val;
	}

	public get totalPages(): number {
		return this._totalPages;
	}
	public documentLoadHandler() {
		var iframe: any = window.document.getElementById("ifrm_hyperlink");
		var document = iframe.contentWindow.document;
		UtilityScripts.addScroll(document);
		this.isLoadFile = true;
	}
}
